import { Autocomplete, Box, CircularProgress, TextField, Typography } from "@mui/material";
import {
  getAttorneyAutocompleteNoOptionsText,
} from "../utils/attorneySearch";
import {
  buildBondAttorneySearchInputHandler,
  buildBondGuardianAttorneyChangeHandler,
  buildBondGuardianAttorneySearchHelperText,
  buildBondGuardianAttorneySearchProps,
  getBondGuardianAttorneyOptionLabel,
  handleBondGuardianManualAttorneyEntry,
  passThroughBondGuardianAttorneyOptions,
  resolveBondGuardianAttorneyValue,
} from "../utils/bondGuardianAttorneyWiring";

export function BondGuardianAttorneySearchForPrincipal({
  attorneySearch,
  guardian,
  guardianIndex,
  updateData,
  data,
  guardians,
  onSelect,
  fieldError = "",
  required = false,
}) {
  return (
    <BondGuardianAttorneySearch
      {...buildBondGuardianAttorneySearchProps({
        attorneySearchInput: attorneySearch.attorneySearchInput,
        setAttorneySearchInput: attorneySearch.setAttorneySearchInput,
        attorneys: attorneySearch.attorneys,
        loadingAttorneys: attorneySearch.loadingAttorneys,
        debouncedSearchAttorneys: attorneySearch.debouncedSearch,
        clearAttorneys: attorneySearch.clearAttorneys,
        guardian,
        guardianIndex,
        updateData,
        data,
        guardians,
        onSelect,
        fieldError,
        required,
      })}
    />
  );
}

export default function BondGuardianAttorneySearch({
  attorneys,
  loadingAttorneys,
  attorneySearchInput,
  setAttorneySearchInput,
  debouncedSearchAttorneys,
  clearAttorneys,
  guardian,
  guardianIndex,
  updateData,
  data,
  guardians,
  onSelect,
  fieldError = "",
  required = false,
}) {
  return (
    <Box sx={{ mt: 2 }}>
      <Autocomplete
        options={attorneys}
        value={resolveBondGuardianAttorneyValue(attorneys, guardian)}
        getOptionLabel={getBondGuardianAttorneyOptionLabel}
        filterOptions={passThroughBondGuardianAttorneyOptions}
        onInputChange={buildBondAttorneySearchInputHandler(
          setAttorneySearchInput,
          debouncedSearchAttorneys
        )}
        noOptionsText={getAttorneyAutocompleteNoOptionsText(
          attorneySearchInput,
          loadingAttorneys
        )}
        loading={loadingAttorneys}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Search Attorney"
            variant="outlined"
            fullWidth
            required={required}
            error={!!fieldError}
            helperText={buildBondGuardianAttorneySearchHelperText(
              attorneySearchInput,
              loadingAttorneys,
              attorneys.length,
              fieldError
            )}
            slotProps={{
              input: {
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loadingAttorneys ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              },
            }}
          />
        )}
        onChange={buildBondGuardianAttorneyChangeHandler(onSelect, guardianIndex)}
      />
      <Typography
        variant="body2"
        className="text-blue-500 cursor-pointer mt-1"
        onClick={() =>
          handleBondGuardianManualAttorneyEntry({
            updateData,
            data,
            index: guardianIndex,
            guardians,
            clearAttorneys,
            setAttorneySearchInput,
          })
        }
      >
        Attorney not in the list?
      </Typography>
    </Box>
  );
}
